module.exports = __webpack_public_path__ + "static/media/paternal.52ca2f4e.svg";